import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { PageHeader, PageHeaderWithBack } from "@/components/common";
import { useAuth } from "@/context/AuthContext";
import { shoppingCentresService } from "@/api/services/shoppingCentres.service";
import { ShoppingCentreDetailsForm } from "./components";
import styles from "./ShoppingCentreCreate.module.css";
export const ShoppingCentreCreate = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useAuth();
    const saveHandlerRef = useRef(null);
    const basePath = location.pathname.startsWith("/staff") ? "/staff" : "/admin";
    const handleSave = async (dto) => {
        const response = await shoppingCentresService.createShoppingCentre(dto);
        return response.data.id;
    };
    const handleBackClick = () => {
        navigate(-1);
    };
    const handleSaveClick = async () => {
        if (saveHandlerRef.current) {
            try {
                const savedId = await saveHandlerRef.current();
                if (savedId) {
                    navigate(`${basePath}/shopping-centres`);
                }
            }
            catch (err) {
                console.error("Error saving:", err);
            }
        }
    };
    return (_jsxs("div", { className: styles.container, children: [_jsx(PageHeader, { userName: user?.name || "User", userEmail: user?.email || "" }), _jsx(PageHeaderWithBack, { title: "Add Shopping Centre", onBack: handleBackClick, breadcrumb: "Shopping Centres/Add Shopping Centre" }), _jsxs("div", { className: styles.contentArea, children: [_jsx(ShoppingCentreDetailsForm, { centre: null, onSave: handleSave, saveHandlerRef: saveHandlerRef }), _jsx("div", { className: styles.summaryActions, children: _jsx("button", { className: styles.saveButton, onClick: handleSaveClick, children: "Save" }) })] })] }));
};
